import {
  ApiBlueprint,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api';
import { agentLaunchPlatformApiRef, AgentLaunchPlatformClient } from './api';

/** Provides the platform client; extension id `api:arrive-agent-launch-platform`. */
export const agentLaunchPlatformApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: agentLaunchPlatformApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new AgentLaunchPlatformClient(discoveryApi, fetchApi),
    }),
});
